import styled from 'styled-components';

const DarkBackdrop = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
`;

export default DarkBackdrop;
